<template>
	<div class="view">
		<div class="team">
			<div class="top">
				Dyelec Lesotho Directors
			</div>
            <div class="people">
                <team-member v-for="(team_member, index) in directors" :key="index" :index="index" :team_member="team_member" />
            </div>
		</div>
	</div>
</template>

<script>
import emitter from '@/emitter';
import TeamFile from '@/content/team.json';
import TeamMember from '@/components/TeamMember';
export default {
	name: 'directors',
	metaInfo: {
		title: 'Directors',
		meta: [
			{
				property: 'og:url',
				content: 'http://www.dyelec.co.ls/directors'
			},
			{
				property: 'og:title', 
				content: 'Dyelec Lesotho | Team'
			},
			{
				name: 'description', 
				content: 'Dyelec Lesotho Directors'
			},
			{
				property: 'og:description', 
				content: 'Dyelec Lesotho Directors'
			},
			// Twitter card
			{
				name: 'twitter:card',
				content: 'Dyelec Lesotho'
			},
			{
				name: 'twitter:title',
				content: 'Dyelec Lesotho | Team'
			},
			{
				name: 'twitter:description',
				content: 'Dyelec Lesotho Directors'
			}
		]
		// override the parent template and just use the above title only
		// titleTemplate: null
	},
	components: {
		TeamMember
	},
	data() {
		return {
			directors: TeamFile.directors
		};
	},
	mounted() {
		emitter.$emit('new-page-name', 'Directors');
	},
};
</script>

<style lang="scss" scoped>
	@import '../assets/style/main.scss';
	.team {
		width: 100%;
		min-height: 100%;
		max-width: 1024px;
		align-self: center;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: flex-start;
		animation: slide-up 500ms ease-in-out both;
		font-size: 1.1em;
		line-height: 1.5em;
		padding: 1em 0em;
		@media (max-width: 1024px) {
			padding: 1em;
		}
		>.top {
			color: $white;
			padding: 1em 1em .5em 0em;
			flex-grow: 0;
			font-size: 1.5em;
			animation: slide-up 500ms ease-in-out both;
		}

	}
</style>